import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { Provider } from 'react-redux';
import { store } from './redux/store.ts';
import { ColorModeProvider } from '@nplan';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <ColorModeProvider>
            <App />
        </ColorModeProvider>
    </Provider>,
);
